module.exports = __webpack_public_path__ + "img/default.d7b7b12d.jpg";